import React, { useState } from 'react'
import BiztantuLoader from '../../Components/Loader'
import { Button, Stack, Typography, Box, Tab } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { StyledConfigurationContainer, StyledIndexContainerDiv, StyledLeadContainer } from '../../Components/Styled'
import { handleValidateCodevalue, searchEntity, statusWidth, templateSubjectWidth, whocolumnWidth, workflowNameWidth, workflowTriggerTypeWidth, workflowTypesWidth } from '../../Utility/constant'
import BiztantuSearch from '../../Components/BiztantuSearch'
import { useDispatch, useSelector } from 'react-redux'
import { privateRoutesPath } from '../../Routes'
import DataGridTable from '../../Components/DataGrid'
import moment from 'moment'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import SearchWorkflowComponent from './SearchWorkflowComponent'
import { requestGetAllWorkflows } from '../../Store/Workflows/action'
import { resetState } from '../../Utility/resetSearchFunction'
import { resetSearch, setSearch } from '../../Store/SearchReducer/action'
import { useEntitySearch } from '../../Utility/hooks/useEntitySearch'
import WorkflowLogsTab from './WorkflowLogsTab'
import { WORKFLOW_TAB_VALUES, workflowTabsConfig, getTriggerTypeForUi } from '../../Utility/workflowConfig'
import { i18nRegistry } from '../../Utility/i18nRegistry'
import useNavigation from '../../Utility/hooks/useNavigation'
import './workflow.css';

const WorkflowPage = () => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const isLoadingProgress = useSelector(state => state.global.isLoading);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const workflows = useSelector(state => state?.workflows?.workflows);

    const dispatch = useDispatch();
    const { navigateTo } = useNavigation();

    const wfSearch = useSelector((state) => state?.search?.workflow) || {};

    const [activeTab, setActiveTab] = useState(WORKFLOW_TAB_VALUES.LIST);
    
    const preserveSearch = useSelector(
        state => state?.search?.preserveSearch?.[searchEntity?.workflow]
    );
       useEntitySearch({
           entity: searchEntity?.workflow,
           searchState: wfSearch,
           isReady : true,
           preserveSearch,
           fetchAction: (params) =>
               requestGetAllWorkflows(
                   params,
               ),
       });

    const handleChangeSearchField = (event) => {
        dispatch(setSearch(searchEntity?.workflow, {
            ...wfSearch,
            [event.target.name]: event.target.value,
        }));
    };

    const handleResetSearch = () => {  
        dispatch(
            resetSearch(searchEntity?.workflow,resetState(wfSearch))
        )
    };

    const handleSearchWorkflow = () => {
        dispatch(requestGetAllWorkflows(wfSearch));
    };

    const handleEditWorkflow = (id) => () => {
        navigateTo(`${privateRoutesPath.CREATE_WORKFLOW}/${id}`,{},searchEntity?.workflow);
    };

    const dataGridData = (workflows || []).map(workflow => ({
        ...workflow,
        triggerType: getTriggerTypeForUi(workflow.triggerType, workflow.triggerConfig),
        processingType: workflow.processingConfig?.map(p => p.processing_type).join(", "),
        actionType: workflow.actionConfig?.map(a => a.action_type).join(", ")
    }));

    const columns = [
        {
            field: 'name',
            headerName: handleValidateCodevalue(internationalise, 'WF_SEARCH_NAME'),
            flex: 1,
            minWidth : workflowNameWidth,
            editable: false,
            renderCell: ({ row }) => (
                <span
                    onClick={handleEditWorkflow(row.id)}
                    className="workflow-name-link"
                >
                    {row.name}
                </span>
            )
        },
        {
            field: 'status',
            headerName: handleValidateCodevalue(internationalise, 'WF_SEARCH_STATUS'),
            flex: 1,
            minWidth: statusWidth,
            editable: false,
            valueGetter: ({ value }) => {
                if (value === null || value === undefined) return ""
                return handleValidateCodevalue(internationalise, value)
            }
        },
        {
            field: 'triggerType',
            headerName: handleValidateCodevalue(internationalise, 'WF_SEARCH_TRIGGER_TYPE'),
            flex: 1,
            minWidth: workflowTriggerTypeWidth,
            editable: false,
        },
        {
            field: 'processingType',
            headerName: handleValidateCodevalue(internationalise, 'WF_SEARCH_PROCESSING_TYPE'),
            flex: 1,
            minWidth : workflowTypesWidth,
            editable: false,
            valueGetter: ({ value }) => {
                if (!value) return ""
                return value.split(", ").map(val => handleValidateCodevalue(internationalise, val)).join(", ")
            }
        },
        {
            field: 'actionType',
            headerName: handleValidateCodevalue(internationalise, 'WF_SEARCH_ACTION_TYPE'),
            flex: 1,
            minWidth : templateSubjectWidth,
            editable: false,
            valueGetter: ({ value }) => {
                if (!value) return ""
                return value.split(", ").map(val => handleValidateCodevalue(internationalise, val)).join(", ")
            }
        },
        {
            field: 'createdAt',
            headerName: handleValidateCodevalue(internationalise, 'COMMON_CREATED_AT'),
            type: 'date',
            flex: 1,
            minWidth: whocolumnWidth,
            editable: false,
            valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        },
        {
            field: 'updatedAt',
            headerName: handleValidateCodevalue(internationalise, 'COMMON_UPDATED_AT'),
            type: 'date',
            flex: 1,
            minWidth: whocolumnWidth,
            editable: false,
            valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        },
    ];


    const renderWorkflowList = () => (
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
            <Box className="workflow-index-container">
                <StyledConfigurationContainer>
                    <Typography variant='h6'>
                        {handleValidateCodevalue(internationalise, 'WF_SEARCH_TITLE')}
                    </Typography>
                </StyledConfigurationContainer>

                <StyledIndexContainerDiv>
                    <StyledLeadContainer className="workflow-search-panel">
                        <Stack className='table-header-search table-header-search-common'>
                            <BiztantuSearch
                                showStatus={false}
                                showOwner={false}
                                entityDetails={wfSearch}
                                handleReset={handleResetSearch}
                                handleSearch={handleSearchWorkflow}
                            >
                                <SearchWorkflowComponent
                                    entityDetails={wfSearch}
                                    handleOnChange={handleChangeSearchField}
                                />
                            </BiztantuSearch>
                        </Stack>
                        <Stack className='secondry-btn-container workflow-list-actions' direction="row">
                    {specificRolePermission?.isWorkflowManage &&
                            <Button
                                className='biztantu-sec-btn'
                                variant="outlined"
                                onClick={() => navigateTo(privateRoutesPath.CREATE_WORKFLOW,{},searchEntity?.workflow)}
                            >
                                {handleValidateCodevalue(internationalise, "WF_CREATE")}
                            </Button>
                    }
                        </Stack>
                    </StyledLeadContainer>

                    <StyledLeadContainer>
                        <DataGridTable
                            isCheckboxReq={false}
                            height='calc(100vh - 270px)'
                            dataGridData={dataGridData}
                            columns={columns}
                        />
                    </StyledLeadContainer>
                </StyledIndexContainerDiv>
            </Box>
        </BiztantuLoader>
    );

    return (
        <Box className="workflow-tabs-container">
            <TabContext value={activeTab}>
                <Box className="workflow-tab-list">
                    <TabList
                        onChange={(_, newValue) => {
                            setActiveTab(newValue);
                            i18nRegistry.clear();
                        }}
                        variant="standard"
                        aria-label="workflow tabs"
                        allowScrollButtonsMobile
                    >
                        {workflowTabsConfig.map(tab => (
                            <Tab
                                key={tab.value}
                                value={tab.value}
                                label={
                                    handleValidateCodevalue(internationalise, tab.labelKey) ||
                                    tab.defaultLabel ||
                                    tab.labelKey
                                }
                            />
                        ))}
                    </TabList>
                </Box>

                <Box className="workflow-tab-content">
                    <TabPanel value={WORKFLOW_TAB_VALUES.LIST} className="workflow-tab-panel">
                        {renderWorkflowList()}
                    </TabPanel>
                    <TabPanel value={WORKFLOW_TAB_VALUES.LOGS} className="workflow-tab-panel">
                        <WorkflowLogsTab />
                    </TabPanel>
                </Box>
            </TabContext>
        </Box>
    );
}

export default WorkflowPage
